import { createContext } from 'react'

export type WebSocketStatus = 'connecting' | 'connected' | 'disconnected' | 'reconnecting'

const CONNECTION_ID_KEY = 'wpc_connection_id'

export function storeConnectionId(connectionId: string): void {
  sessionStorage.setItem(CONNECTION_ID_KEY, connectionId)
}

export function getStoredConnectionId(): string | null {
  return sessionStorage.getItem(CONNECTION_ID_KEY)
}

export function clearStoredConnectionId(): void {
  sessionStorage.removeItem(CONNECTION_ID_KEY)
}

export interface WebSocketMessage<T = unknown> {
  event: string
  connectionId?: string
  data?: T
  echo?: unknown
}

export interface WebSocketContextValue {
  /** Current connection status */
  status: WebSocketStatus
  /** Connection ID returned from the server */
  connectionId: string | null
  /** Whether the WebSocket is currently connected */
  isConnected: boolean
  /** Number of reconnection attempts made */
  reconnectAttempts: number
  /** Send a message through the WebSocket */
  sendMessage: <T>(message: T) => void
  /** Manually reconnect the WebSocket */
  reconnect: () => void
  /** Manually disconnect the WebSocket */
  disconnect: () => void
  /** Subscribe to incoming messages */
  subscribe: <T>(eventType: string, handler: (data: WebSocketMessage<T>) => void) => () => void
  /** Last error that occurred */
  lastError: Error | null
}

export const WebSocketContext = createContext<WebSocketContextValue | null>(null)
